import React from 'react'
import dayjs from 'dayjs'


export default ({row,name}) => {

    if( ! row[name] ) {
        return null
    }

    return <div>{dayjs(row[name]).fromNow()}</div>
}